'use strict';

angular.module('licensure.services')
    .factory('CMSPages', ['$http', '$q', function ($http, $q) {
        return {
            get: function (args) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/CMSPages', {
                    params: args
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getMenu: function (args) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/CMSPages/getmenu', {
                    params: args
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }

        }
    }])
;